import AdminReport from '../../features/admin/AdminReport'

const AdminReportPage = () => {
    return (
        <AdminReport />
    )
}

export default AdminReportPage